import { AppButton, AppTitle } from 'components/atoms';
import { EnrollmentErrorModal } from 'components/organisms/EnrollmentErrorModal/EnrollmentErrorModal';
import { useState } from 'react';
import { ChildHead, UsersGroup } from 'assets';
import { Container } from 'pages/enrollment/EnrolmentItem/EnrollmentItem.styled';

export const EnrolmentItem = () => {
    const [openEnrollmentErrorModal, setOpenEnrollmentErrorModal] = useState(false);

    const handleEnrollmentErrorModalOpen = () => {
        setOpenEnrollmentErrorModal(true);
    };

    const handleEnrollmentErrorModalClose = () => {
        setOpenEnrollmentErrorModal(false);
    };

    return (
        <Container vertical align="center" gap={32}>
            <EnrollmentErrorModal
                open={openEnrollmentErrorModal}
                onClose={handleEnrollmentErrorModalClose}
            />
            <UsersGroup />
            <AppTitle margin={0} textAlign="center" level={4}>
                Rekrutacja [schoolYear] [institutionName]
            </AppTitle>
            <AppButton
                type="primary"
                onClick={handleEnrollmentErrorModalOpen}
                margin={0}
                size="large"
                icon={<ChildHead />}
            >
                Dołącz do rekrutacji
            </AppButton>
        </Container>
    );
};
